import React, { useState } from "react";
import { MAX_COMMENT_LENGTH } from "../utils/limits";

const PostFeed = ({ posts, user, onLike, onComment, onDeletePost, onDeleteComment }) => {
  const [commentTexts, setCommentTexts] = useState({}); // Keep comment text per post

  const handleCommentChange = (postId, text) => {
    setCommentTexts((prev) => ({ ...prev, [postId]: text }));
  };

  const handleCommentSubmit = (postId) => {
    const text = commentTexts[postId];
    if (!text?.trim()) return;
    onComment(postId, text);
    setCommentTexts((prev) => ({ ...prev, [postId]: "" }));
  };

  return (
    <div className="post-feed">
      {posts.length === 0 && <p>No posts yet. Be the first!</p>}

      {posts.map((post) => {
        const likedByUser = user && post.likes?.includes(user.username);
        const isMine = user && post.username === user.username;

        return (
          <div key={post._id} className="post-card">
            <div className="post-header">
              <h4>@{post.username}</h4>
              <span className="post-date">
                {new Date(post.createdAt).toLocaleString()}
              </span>
              {isMine && (
                <button
                  className="delete-btn"
                  onClick={() => onDeletePost(post._id)}
                  title="Delete this post"
                >
                  Delete
                </button>
              )}
            </div>

            <p className="post-content">{post.content}</p>

            {/* Likes */}
            <button
              onClick={() => user ? onLike(post._id) : null}
              style={{ cursor: user ? "pointer" : "default" }}
              aria-pressed={Boolean(likedByUser)}
              title={
                user
                  ? likedByUser ? "Click to unlike" : "Click to like"
                  : "Login to like"
              }
            >
              {likedByUser ? "❤️" : "🤍"} {post.likes?.length || 0}
            </button>

            {/* Comments */}
            <div className="comments-section">
              {post.comments?.length > 0 && (
                <div className="comments-header">💬 Comments:</div>
              )}
              {post.comments?.map((c, i) => {
                // The comment's author can remove it, and so can the post's
                // author — the same rule the API enforces.
                const canDelete =
                  user && (c.username === user.username || isMine);
                return (
                  <p key={c._id ?? i} className="comment">
                    <strong>@{c.username}:</strong> {c.text}
                    {canDelete && c._id && (
                      <button
                        className="delete-btn"
                        onClick={() => onDeleteComment(post._id, c._id)}
                        title="Delete this comment"
                      >
                        Delete
                      </button>
                    )}
                  </p>
                );
              })}
            </div>

            {/* Comment input */}
            {user && (
              <div className="comment-box">
                <input
                  type="text"
                  placeholder="Add a comment..."
                  maxLength={MAX_COMMENT_LENGTH}
                  value={commentTexts[post._id] || ""}
                  onChange={(e) => handleCommentChange(post._id, e.target.value)}
                />
                <button onClick={() => handleCommentSubmit(post._id)}>
                  Comment
                </button>
                {(commentTexts[post._id] || "").length >
                  MAX_COMMENT_LENGTH - 100 && (
                  <span className="char-count">
                    {(commentTexts[post._id] || "").length}/{MAX_COMMENT_LENGTH}
                  </span>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PostFeed;
